import { logEvent as firebaseLogEvent, setUserId } from 'firebase/analytics';
import { analyticsReady } from './firebase-config';

// Wrapper seguro: espera a que analytics esté listo antes de loguear.
// Si no está soportado (analytics === null), no hace nada.
export const logAppEvent = async (
  eventName: string,
  params?: Record<string, unknown>
) => {
  const analytics = await analyticsReady;
  if (!analytics) return;
  firebaseLogEvent(analytics, eventName, params);
};

// Asocia el UID de Firebase Auth a los eventos de Analytics.
// Pasar null al cerrar sesión para desvincular.
export const setAnalyticsUser = async (uid: string | null) => {
  const analytics = await analyticsReady;
  if (!analytics) return;
  setUserId(analytics, uid);
};

// Eventos específicos de la app, para no repetir strings sueltos por el código
export const trackPageView = (pagePath: string, pageTitle?: string) =>
  logAppEvent('page_view', { page_path: pagePath, page_title: pageTitle });

export const trackLogin = () =>
  logAppEvent('login', { method: 'password' });

export const trackLogout = () =>
  logAppEvent('logout');

export const trackLevelUp = (nivel: number) =>
  logAppEvent('level_up', { level: nivel });

export const trackReward = (recompensaNombre: string) =>
  logAppEvent('redeem_reward', { reward_name: recompensaNombre });
